/**
 * Created by Ning Jiang on 2/7/2018.
 */
import {StepCountUpBigWinController} from "@nolimitcity/slot-game/bin/game/winpresentation/bigwin/stepcountup/StepCountUpBigWinController";
import {BonusBunniesBigWinView} from "./BonusBunniesBigWinView";
import {Timeline, TimelineLite} from "gsap";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BonusBunniesGameMode} from "../../gamemode/BonusBunniesGameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunniesBigWinCountUp} from "./BonusBunniesBigWinCountup";
import {BigWinCoinsFountain} from "../../coinfountain/BigWinCoinsFountain";
import {BonusBunniesSoundConfig} from "../../BonusBunniesSoundConfig";

export class BonusBunniesBigWinController extends StepCountUpBigWinController {

    private _gameView:BonusBunniesBigWinView;
    private _winCountUp:BonusBunniesBigWinCountUp;

    constructor(indexes:[number, number]) {
        super(indexes, {
            skipLastLevelCountUpIfSmall : true,
            skippableOnEachLevel : true
        });
        this._gameView = new BonusBunniesBigWinView();
        this._winCountUp = new BonusBunniesBigWinCountUp();
        this._winCountUp.position.set(360, GameConfig.instance.GAME_HEIGHT * 0.7);
        StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._winCountUp);
    }

    protected hasWin():boolean {
        return ((this._gameData != null) && (this._gameData.isBigWin) && (this._gameData!.mode !== BonusBunniesGameMode.BONUS_GAME));
    }

    protected startWinPresentation():void {
        SlotGame.sound.fadeAmbience(0, 500);
        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BIG_WIN);
        super.startWinPresentation();
    }

    protected getBigWinLevelAnimation(level:number):Timeline {
        return this._gameView.getBigWinLevelAnimation(level, this._winRatios[level]);
    }

    protected playCountUp(from:number, to:number, duration:number, preTotalWin:number = 0):Timeline | null {
        return this._winCountUp.getCountUpAnimation(from, to, duration);
    }

    protected playEndingAnimation(isAborted:boolean):void {
        this._gameView.playEndingAnimation(this._winRatios[this._winLevel]);
        SlotGame.winFieldController.showWinField();
        this._winCountUp.abort(this._gameData!.singleWin, isAborted);
        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BIG_WIN_ENDS);
        const stopSoundsTL:TimelineLite = new TimelineLite();
        stopSoundsTL.add(() => SlotGame.sound.stopEffect(BonusBunniesSoundConfig.instance.BIG_WIN), "+=0.318");
        SlotGame.sound.fadeAmbience(1, 1500);
    }

    public getCoinFountain():BigWinCoinsFountain {
        return this._gameView.coinsFountain;
    }

    public getCoinFountainContainer():PIXI.Container {
        return this._gameView.coinsFountainContainer;
    }
}